<div #docViewerContent class="app-document-viewer-content relative inline-block p1 border-box">
  <pdf-viewer
    [src]="pdfOptions"
    [render-text]="true"
    [zoom]="zoom"
    [original-size]="true"
    (after-load-complete)="onPdfLoaded($event)"
    (page-rendered)="onPageRendered($event)"
  ></pdf-viewer>

  <div *ngIf="pdfDoc" class="app-document-overlay p1">
    <ng-container *ngFor="let i of pdfDoc.numPages | numberToIterable">
      <div
        *ngIf="originalPagesSizes[i]"
        class="app-document-overlay-page relative"
        [class.overflow-hidden]="hideOverflow"
        [style.width.px]="originalPagesSizes[i][0] * zoom"
        [style.height.px]="originalPagesSizes[i][1] * zoom"
      >
        <div class="app-document-overlay-page-scale" [style.transform]="'scale(' + zoom + ')'">
          <ng-container *ngTemplateOutlet="pageOverlayTmp; context: { index: i }"></ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
